export const WEIGHTED_INFO_MSG =
  'Expressed in thousands, the projected number of adults (18+) in the U.S. who meet the persona criteria.';
export const REACH_INFO_MSG =
  'The percentage of the weighted U.S. population that can be reached by this persona criteria.';
export const SAMPLE_INFO_MSG =
  'The number of people surveyed who meet the selection criteria.';

// Persona Creator Messages
export const PERSONA_CREATOR_DEF_LENGTH_WARNING =
  'Definition name can be 64 character max';
export const DUPLICATE_DEFINITION_WARNING =
  'Definition name already exists. Please enter a unique definition name.';
export const DATA_SAVE_SERVER_ERROR =
  'Failed to save. Kindly contact Simmons administrator.';
export const SEGMENT_LABEL_TEXT_EXCEED_WARNING =
  'Segment name should not more than ';
export const DUPLICATE_SEGMENT_WARNING =
  'Segment name already exists. Please enter a unique segment name.';

export const SAMPLE_SIZE_RESTRICTION_WARNING =
  'Requires a minimum of 3 segments with sample 60 to compare. Decrease number of segments to create.';

export const NO_VALID_SEGMENT_DATA_MSG =
  'Inadequate sample to generate results. Create or select a new persona to view segment.';

export const DEFAULT_SEGMENT_MESSAGE_SEGMENT_POPUP =
  'Select 3 segments with sample size greater than or equal to 60';

export const ATTITUDINAL_TEMPLATE_NAME_EXCEED_WARNING =
  'Template name can be 60 character max';

export const ATTITUDINAL_TEMPLATE_NAME_SAVE_SUCCESS =
  'Template has been saved successfully';

export const PERSONA_FOLDER_NAME_EXCEED_WARNING =
  'Folder name can be 60 character max';

export const STORIES_FAILURE_MESSAGE_500_STATUS =
  'An error occurred. Please try again later';

export const SAVE_AUDIENCE_TEMPLATE_LENGTH_WARNING =
  'Audience template name can be 128 character max';

export const SALES_CATALYST_DUPLICATE_DEFINITION_WARNING =
  'Definition name already exists. Please enter a unique definition name.';

export const SALES_CATALYST_DEFINITION_LENGTH_WARNING =
  'Definition name can be 64 character max';

export const INSIGHTS_REPORTS_QUESTION_REFRESH_WARNING =
  'Data refresh, please select question to continue.';

export const INSIGHTS_REPORT_NO_DATA_MSG =
  'No Results Found. Please refine your search.';

export const INSIGHTS_DEEP_DIVE_REPORT_NO_DATA_MSG =
  'No Results Found. Please refine your search.';

export const NO_DATA_AVAILABLE_MSG = 'No Data Available';
export const SALES_CATALYST_BRAND_REQUIRED_CHART_MSG = 'Brand required to populate chart';
export const SAVE_SC_SUBENTITIES_LIST_LENGTH_WARNING =
  'List name can be 128 character max';
export const SAVE_SC_SUBENTITIES_LIST_EMPTY_ITEM_WARNING =
  'Requires a minimum of 1 sub-entitiy to save list.';
export const SALES_CATALYST_OVERLAP_SUBENTITY_CHART_HEADER = 'TOP ENTITYNAME CONSUMED BY';
export const SALES_CATALYST_BRAND_CHART_HEADER = 'TOP BRANDS CONSUMED BY';
export const CLICK_RUN_REPORT_MSG = 'click run to generate report';
export const SC_SUBENTITIES_LIST_DUPLICATE_WARNING =
  'Data point already exists.';
export const SC_SAVE_MODIFIED_LIST =
  'Please save the modified list.';
export const SC_SAVE_LIST_CONFIRMATION_MSG =
  'Would you like to update the existing list or save as a new list?';
export const INVALID_DATA_POINTS = 'Data points are not available for this study';
export const SC_PACKAGE_EDIT_LIST_WARNING = 'Data not available for this study';
export const SC_SAMPLE_VALUE_NULL_ERROR_MESSAGE =
  'Sample = 0, cannot run analysis';
export const SC_COMPETITOR_COLUMN_CHART_HEADING = 'SHARE OF BASE & TARGET MARKET';
export const SC_INVALID_COMBINATION_MSG = 'Combination does not generate results';

// User Preferences messages
export const DATA_INPUT_LIST_DUPLICATE_WARNING = 'Data point already exists.';
export const SAMPLE_VALUE_NULL_ERROR_MESSAGE = 'Sample = 0, cannot run analysis';
export const SAVE_LIST_EMPTY_ITEM_WARNING = 'Requires a minimum of 1 data point to save list';
export const SC_SAVE_MODIFIED_PACKAGE_LIST = 'Please save modified package list.';
export const CREATOR_CLUSTER_COUNT_WARNING_MSG = `The amount of answers in the clustering statement that
you've selected is less than the max solution clusters. Please select more clustering statements or decrease the
max solution clusters.`;

